import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IContactModel } from '@apps-common/types/portal/contact'

export const QUERY_KEY_PORTAL_GET_CONTACT = 'getContact'

export const getContact = async (): Promise<IContactModel> => axios.get('/me/GetMyDetails').then((res) => res.data?.data)

type QueryFnType = typeof getContact

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useGetContact = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: [QUERY_KEY_PORTAL_GET_CONTACT],
    queryFn: () => getContact()
  })
